import React, {Component} from 'react';
import {Button, Col, Image, Label, Panel, Row} from 'react-bootstrap';
import {Redirect, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';


const MockupOrderCard = ({order}) => (
    <Panel>
        <Panel.Heading style={{backgroundColor: '#f1f2f3', backgroundImage: 'none', paddingTop: 14, paddingBottom: 14}}>
            <span><Label style={{padding: 8, fontWeight: 500, backgroundColor: '#f1f2f3', color: 'black', border: '1px  grey'}} ><span style={{fontSize: 14}}>Order ID - {order._id}</span></Label></span>
            <span className="pull-right"><Button target="blank" style={{marginTop: '-5px'}} href={global.config.server_path + order.skus[0].output_file} bsStyle="blue-adapt" bsSize="small"><span className="fa fa-download" />&nbsp; Download Now</Button> </span>                        
        </Panel.Heading>
        <Panel.Body>
            <Row style={{paddingTop: 5, paddingBottom: 5}}>
                <Col xs={4} align="center">
                    <Image style={{maxHeight: 150, maxWidth: '100%', objectFit: 'contain'}} src={global.config.server_path + order.skus[0].output_file} />
                </Col>
                <Col xs={8} align="center">
                    <Row style={{padding: '5px'}}>
                        <Col xs={2}>
                            <b>Mockup</b>
                        </Col>
                        <Col xs={4}>
                            <p>Order placed on</p><p>{new Date(order.createdAt).toDateString()}</p>
                        </Col>
                        <Col xs={6} align="right">
                            <p style={{color: '#2572CE'}}> Payment successful &nbsp; <span className="fa fa-check"/> </p>
                            {order.status == 'fulfilled' ? (<p style={{color: '#2572CE'}}> Order Fulfilled &nbsp; <span className="fa fa-check"/> </p>)
                            : (<p style={{color: 'red'}}> Order Pending &nbsp; <span className="fa fa-times"/> </p>)}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Panel.Body>
        <Panel.Footer style={{backgroundColor: '#f1f2f3', backgroundImage: 'none'}}>
            <Row style={{fontWeight: 'bold'}}>
                <Col xs={6} className="text-left">Order Total</Col>
                <Col xs={6} className="text-right">${order.amount} USD</Col>
            </Row>
        </Panel.Footer>
    </Panel>
)


class Orders extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            order_history : [],
        }
    }

    componentDidMount() {
        this.fetch_order_history();
    }

    fetch_order_history = async () => {
        try {
            var _url = global.config.server_path+'user/fetch_order_history/';
            var order_history = await fetch(_url, {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include' });
            order_history = await order_history.json();
            order_history = order_history.data.filter(x => (x.skus && x.skus.length && x.skus[0].type == 'mockup'));
            console.log('order history --> ', order_history);
            this.setState({ order_history });
        } catch(err) {

        }
    } 

    download_file = src => {
        var download = window.document.createElement('a');
        download.href = src
        download.download = 'mockup.png'
        download.click();
    }


    render() {

        if (!this.props.user) {
            return <Redirect to="/mockupmaker"/>
        }

        return(
            <div>
                <Row style={{'borderTop': '1px solid #e6e6e6', paddingTop: 75}}>
                    <Col xs={2} style={{'borderRight': '1px solid #e6e6e6', height: 'calc(100vh - 75px)', 'backgroundColor': '#f8f8f8'}} />
                    <Col xs={8} style={{height: 'calc(100vh - 75px)', overflowY: 'scroll'}}>
                        <Row style={{'height': '5vh', 'padding': '20px', 'fontSize':'x-large', textAlign: 'center'}}>
                            <b>Your Orders</b>
                        </Row>
                        <Row style={{'padding': '20px'}}>
                            {this.state.order_history.map(order => (
                                <Col xs={12}>
                                    <MockupOrderCard order={order} />
                                </Col>
                            ))}                        
                        </Row>
                    </Col>
                    <Col xs={2} style={{'borderLeft': '1px solid #e6e6e6', 'backgroundColor': '#f8f8f8', height: 'calc(100vh - 75px)'}} />
                </Row>
            </div>
        )
    }

}

const mapStateToProps = state => ({
    user: state.user,
})

const mapDispatchToProps = dispatch => ({})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Orders));